import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import logo from '../images/logo.png';

class PageNotFound extends Component {
	render() {
		return (
			<div>
				<header>
					<figure>
          				<Link to='/'><img className="img-responsive" src={logo} alt="Gnabagam Logo" /></Link>
      				</figure>   
			    </header>

			    <section class="alternative-pages">
			      <div className="container">
			        <h2>Page Not Found</h2>
			        <hr/>

			        <p>To return to the main page click <Link to='/'>here</Link></p>
			      </div>
			    </section>
			</div>
		)
	}
}

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/components/PageNotFound.js